import styled from '@emotion/styled';

export const ModalContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 280px;
  height: 100%;
  overflow: hidden;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr 260px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.offWhite};
`;

export const ProductShowcase = styled.div`
  height: 200px;
  background: ${({ theme }) => theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  border-bottom: 2px solid ${({ theme }) => theme.colors.offWhiteDark};

  @media (max-width: 768px) {
    height: 140px;
  }
`;

export const ProductMainImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const OptionsScrollArea = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 2rem 2.4rem;

  @media (max-width: 1024px) {
    padding: 1.6rem 2rem;
  }

  @media (max-width: 768px) {
    padding: 1.6rem;
  }

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.tanLight};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.tanDark};
    border-radius: 4px;
  }
`;

export const SummaryPanel = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border-left: 2px solid ${({ theme }) => theme.colors.offWhiteDark};
  display: flex;
  flex-direction: column;
  height: 100%;

  @media (max-width: 768px) {
    display: none;
  }
`;

// Export all components
export default {
  ModalContent,
  MainContent,
  ProductShowcase,
  ProductMainImage,
  OptionsScrollArea,
  SummaryPanel,
};
